import { Injectable, Injector } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class ModalService {
    private modalService: NgbModal;

    constructor(private injector: Injector) {
        this.modalService = this.injector.get(NgbModal);
    }

    openModal(content: any, size: 'sm' | 'lg' | 'xl' | string = ''): NgbModalRef {
        return this.modalService.open(content, {centered: true, backdrop: 'static', keyboard: false, size: size});
    }
}

